<script>
import { CONVERSATION_PRIORITY } from '../../../../shared/constants/messages';

export default {
  name: 'PriorityMark',
  props: {
    priority: {
      type: String,
      default: '',
      validate: value =>
        [...Object.values(CONVERSATION_PRIORITY), ''].includes(value),
    },
  },
  data() {
    return {
      CONVERSATION_PRIORITY,
    };
  },
  computed: {
    tooltipText() {
      return this.$t(
        `CONVERSATION.PRIORITY.OPTIONS.${this.priority.toUpperCase()}`
      );
    },
    isUrgent() {
      return this.priority === CONVERSATION_PRIORITY.URGENT;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <span
    v-if="priority"
    v-tooltip="{
      content: tooltipText,
      delay: { show: 1500, hide: 0 },
    }"
    class="shrink-0 rounded-full inline-flex items-center justify-center w-5 h-5 aspect-square"
    :class="{
      'bg-red-500': priority === CONVERSATION_PRIORITY.URGENT,
      'bg-orange-500': priority === CONVERSATION_PRIORITY.HIGH,
      'bg-yellow-500': priority === CONVERSATION_PRIORITY.MEDIUM,
      'bg-grass-500': priority === CONVERSATION_PRIORITY.LOW,
    }"
  >
    <fluent-icon
      :icon="`priority-${priority.toLowerCase()}`"
      :size="isUrgent ? 12 : 14"
      class="flex-shrink-0 text-white"
      view-box="0 0 14 14"
    />
  </span>
</template>
